<h2 mat-dialog-title style="font-weight: normal; padding: 1rem 1rem 0px">
	<div fxFlex>
		<div *ngIf="stepper.selectedIndex == 0">{{ title }}</div>
		<div *ngIf="stepper.selectedIndex == 1">{{ secondStepTitle }}</div>
		<div *ngIf="stepper.selectedIndex == 2">{{ thirdStepTitle }}</div>

		<div *ngIf="subtitle && stepper.selectedIndex == 0" class="font-size-13">
			{{ subtitle }}
		</div>
	</div>
	<div fxFlex="15" fxLayoutAlign="end center">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color" style="cursor: pointer"
			>close</mat-icon
		>
	</div>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content style="margin: 1px; font-size: 12px">
	<mat-horizontal-stepper #stepper [linear]="true" fxFlex="100">
		<mat-step>
			<ng-template matStepLabel>Upload file</ng-template>
			<app-first-step
				(fileCleared)="clearFile()"
				(fileLoadedAndHeadersValidated)="afterFirstStep($event)"
				[dataType]="dataType"
				[expectedHeadersMap]="expectedHeadersMap"
				[expectedHeaders]="expectedHeaders"
			>
			</app-first-step>
		</mat-step>
		<mat-step [completed]="allLines.length > 0">
			<ng-template matStepLabel>Map fields</ng-template>
			<app-second-step
				#mapFields
				(goBack)="goBack()"
				(headersMapped)="afterSecondStep($event)"
				*ngIf="allLines.length > 0"
				[dataType]="dataType"
				[expectedHeadersMap]="expectedHeadersMap"
				[formGroupObject]="formGroupObject"
				[headers]="allLines[0].split(',')"
				[requiredHeaders]="requiredHeaders"
			>
			</app-second-step>
		</mat-step>
		<mat-step [completed]="showPreview" style="margin-bottom: 1rem">
			<ng-template matStepLabel>Preview</ng-template>
			<app-third-step
				#preview
				(goBack)="goBack()"
				(resetForm)="resetForm()"
				(uploadFileEvent)="closeDialog(allLines)"
				[allLines]="allLines"
				[dataType]="dataType"
				[errorMsgs]="errorMsgs"
			>
			</app-third-step>
		</mat-step>
	</mat-horizontal-stepper>
</mat-dialog-content>

<mat-divider *ngIf="showActions()"></mat-divider>
<mat-dialog-actions class="default-dialog-action">
	<div *ngIf="isFirstStep()" fxFlex fxLayoutAlign="space-evenly center">
		<button (click)="goBack()" mat-button mat-raised-button style="background-color: #f5f5f5">
			Back
		</button>
		<button
			(click)="mapFieldsComponent?.afterMapping()"
			[disabled]="mapFieldsComponent?.headerMapFormGroup?.invalid"
			class="focused-button"
			color="primary"
			mat-button
			mat-raised-button
		>
			Next
		</button>
	</div>

	<div *ngIf="isSecondStep()" fxFlex fxLayoutGap="1rem">
		<div *ngIf="previewComponent.errorMsgs.length > 0" fxLayoutAlign="end end">
			<button (click)="resetForm()" color="primary" mat-button mat-raised-button>Reset</button>
		</div>

		<div *ngIf="previewComponent.errorMsgs.length == 0" fxLayout="row" fxLayoutGap="1rem">
			<div *ngIf="dataType === 'priceLane'" fxFlex fxLayoutAlign="start center">
				Trailer Types: Van, Reefer, Flatbed, StepDeck, Container
			</div>

			<div *ngIf="dataType === 'load'" fxFlex>
				<mat-checkbox
					(change)="carrierOfferStatusChanged()"
					[(ngModel)]="currentCarrierOffersStatus"
					[color]="'primary'"
					[labelPosition]="'after'"
					class="fs-13"
					[disabled]="IS_BOOKING_ASSISTANT_ACCOUNT_SETTING_DISABLED"
				>
					Get Options - Check this box to trigger Booking Assistant for all imported loads.
				</mat-checkbox>
			</div>
			<div fxFlex fxLayoutAlign="end end">
				<button (click)="goBack()" mat-button mat-raised-button style="background-color: #f5f5f5">
					Back
				</button>
				<button
					(click)="previewComponent.uploadFile()"
					color="primary"
					mat-button
					mat-raised-button
				>
					Upload
				</button>
			</div>
		</div>
	</div>
</mat-dialog-actions>
